<script setup>
import { onMounted, ref } from 'vue';
import { FlipColor } from '@/core/js/FlipColor';

const props = defineProps({
    icon: { type: [String, Boolean], default: 'dollar' },
    color: { type: String, default: 'dark-blue' },
    external: { type: Boolean, default: false },
});
const flipped = ref('');

onMounted(() => {
    flipped.value = FlipColor(props.color);
});
</script>

<template>
    <component
        :is="external ? 'a' : 'router-link'"
        :target="external ? '_blank' : ''"
        class="BtnPill group relative mb-4 inline-flex cursor-pointer items-start overflow-hidden rounded-2xl py-2 pr-8 text-xs leading-tight md:rounded-3xl md:text-base md:leading-tight xl:text-lg xl:leading-tight"
        :class="[
            'bg-' + color,
            {
                'pl-5': icon !== false,
                'pl-8': icon == false,
            },
        ]"
    >
        <span
            v-if="icon"
            class="BtnPill__icon ml-[-0.8rem] mr-3 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white transition duration-500 group-hover:scale-130 md:h-7 md:w-7"
            :class="['text-' + color]"
        >
            <slot name="icon">
                <Icon
                    :type="icon"
                    class="h-19/24 transition duration-500 group-hover:scale-60"
                    svgclass="h-full w-auto fill-current"
                />
            </slot>
        </span>
        <span class="BtnPill__inner inline-flex flex-wrap items-center">
            <span
                v-if="$slots.label"
                class="BtnPill__label relative top-[0.2em] mr-3"
                :class="['text-' + flipped]"
            >
                <slot name="label" />
            </span>
            <span
                v-if="$slots.text"
                class="BtnPill__text relative top-[0.2em] text-white"
            >
                <slot name="text" />
            </span>
        </span>
    </component>
</template>
